import type { SVGProps } from 'react';
const SvgCross = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Cross Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M3.964 3.964l10.572 10.572M14.536 3.964L3.964 14.536" />
    </g>
  </svg>
);
export default SvgCross;
